'use client';
import { omitBy } from 'lodash-es';
import { PropsWithChildren, useRef } from 'react';
import { LogParams } from '~/apis/log';
import { useSendLog } from '~/hooks';
import { useImpressionObserver } from '~/hooks/useImpressionObserver';

type Props = {
  params: LogParams;
};
export const LogImpression = ({ children, params }: PropsWithChildren<Props>) => {
  const sendLog = useSendLog();
  const ref = useRef<HTMLDivElement>(null);

  useImpressionObserver(ref, () => {
    if (!ref || !params) return;
    const logParams = omitBy(params, (value) => value === undefined || value === '');
    sendLog({
      ...logParams,
    });
  });

  return <div ref={ref}>{children}</div>;
};
